import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = {
  class: "dialog-custom__content form-custom",
  style: {"height":"calc(100vh - 30%)"}
}
const _hoisted_4 = { class: "dialog-message__grid" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = {
  class: "p-field-label",
  for: "messagetitle"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = {
  class: "p-field-label mb-3",
  for: "messagetext"
}
const _hoisted_9 = { class: "message-text" }
const _hoisted_10 = { class: "p-field-label char-remain-count" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "p-field-label mb-3" }
const _hoisted_13 = { class: "p-field mt-3" }
const _hoisted_14 = { class: "p-field-label" }
const _hoisted_15 = { class: "p-field mt-3" }
const _hoisted_16 = { class: "p-field-label" }
const _hoisted_17 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDialogVisible = $event)),
    showHeader: false,
    modal: true,
    onHide: _ctx.doHideDialog,
    class: "dialog-custom dialog-message"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_5, [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.GateMessateTitleUpper")), 1),
              _createVNode(_component_InputText, {
                modelValue: _ctx.message.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.message.title = $event)),
                id: "messagetitle",
                type: "text",
                class: "w-100",
                validator: '/^(?!\s).+(?<!\s)$'
              }, null, 8, ["modelValue", "validator"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.GateMessateTextUpper")), 1),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.message.text,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.message.text = $event)),
                  class: "message-text__area",
                  id: "messagetext",
                  maxlength: _ctx.messageMaxLength
                }, null, 8, ["modelValue", "maxlength"]),
                _createVNode("label", _hoisted_10, _toDisplayString(`${_ctx.remainingChars} ${_ctx.$t(
                                    "AppResourceEP.HomepageMessageRemaingChar"
                                )}`), 1)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResourceEP.SelectGateMessage")), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.gates, (g, gateIdx) => {
                return (_openBlock(), _createBlock("div", {
                  key: g.gateId
                }, [
                  _createVNode(_component_ListItemCheck, {
                    modelValue: _ctx.message.gateIds,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.message.gateIds = $event)),
                    label: g.name,
                    value: g.gateId,
                    name: "specificGate",
                    inputId: 'specificg' + gateIdx,
                    last: 
                                    gateIdx ==
                                    _ctx.currentEntrancePlantGatesCount - 1
                                
                  }, null, 8, ["modelValue", "label", "value", "inputId", "last"])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.FromTime")), 1),
              _createVNode(_component_Calendar, {
                class: "w-50",
                modelValue: _ctx.message.durationSince,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.message.durationSince = $event)),
                "min-date": _ctx.minDate,
                "max-date": _ctx.maxDate,
                dateFormat: "dd MM yy",
                manualInput: false,
                showIcon: "",
                icon: "pi pi-chevron-down"
              }, null, 8, ["modelValue", "min-date", "max-date"]),
              _createVNode(_component_Calendar, {
                class: "ml-4",
                modelValue: _ctx.message.durationSince,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.message.durationSince = $event)),
                timeOnly: "",
                manualInput: false,
                showIcon: "",
                icon: "pi pi-chevron-down"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.ToTime")), 1),
              _createVNode(_component_Calendar, {
                class: "w-50",
                modelValue: _ctx.message.durationUntil,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.message.durationUntil = $event)),
                dateFormat: "dd MM yy",
                showIcon: "",
                icon: "pi pi-chevron-down",
                manualInput: false,
                "min-date": _ctx.minDurationUntilDate,
                "max-date": 
                                new Date(
                                    _ctx.startDate.getFullYear(),
                                    _ctx.startDate.getMonth(),
                                    _ctx.startDate.getDate() + 365
                                )
                            
              }, null, 8, ["modelValue", "min-date", "max-date"]),
              _createVNode(_component_Calendar, {
                class: "ml-4",
                modelValue: _ctx.message.durationUntil,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.message.durationUntil = $event)),
                timeOnly: "",
                manualInput: false,
                showIcon: "",
                icon: "pi pi-chevron-down",
                minDate: 
                                _ctx.message.durationSince &&
                                _ctx.message.durationSince > new Date()
                                    ? _ctx.message.durationSince
                                    : new Date()
                            
              }, null, 8, ["modelValue", "minDate"])
            ])
          ])
        ])
      ]),
      _createVNode("footer", _hoisted_17, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: 
                    _ctx.isEdit ? _ctx.$t('AppResource.Save') : _ctx.$t('AppResource.Create')
                ,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}